import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'

export enum QUESTION_SURVEY_GET_PAYLOAD_TYPE {
  QUALIFICATION_STEP = 'qualification_step',
  QUALIFICATION_SCORING = 'qualification_scoring',
  QUALIFICATION_VALIDATION = 'qualification_validation',
}

export enum CATEGORY_SURVEY_TYPE {
  PI = 'pi',
  QCE = 'qce',
  ESG = 'esg',
}

export type CategorySurveyType =
  (typeof CATEGORY_SURVEY_TYPE)[keyof typeof CATEGORY_SURVEY_TYPE]

export enum SURVEY_PROVIDER {
  LCL = 'lcl',
  LCL_MINOR = 'lcl_minor',
}

export type SurveyProvider =
  (typeof SURVEY_PROVIDER)[keyof typeof SURVEY_PROVIDER]

export enum CATEGORY_SURVEY_RESULT {
  pi = 'pi_results',
  qce = 'qce_results',
}

export const ANSWER_TYPE = {
  verticalButtons: 'BV',
  horizontalButtons: 'BH',
  checkbox: 'CC',
  string: FIELD_TYPES.string,
  number: FIELD_TYPES.number,
} as const
